// extracted by mini-css-extract-plugin
export default {"topSection":"style_topSection__YOFLi","nftWrapper":"style_nftWrapper__9w7Im","cardsContainer":"style_cardsContainer__nsEt-"};